
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/[slug]",
      function () {
        return require("private-next-pages/about/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/[slug]"])
      });
    }
  